import React, { Component } from 'react';
import styled from 'styled-components';
const Root = styled.div `
  width: 100%;
  height: 0.48rem;
  padding: 0 0.6rem;
  line-height: 0.48rem;
  background-color: rgba(255, 87, 26, 0.1);
  border-radius: 2px;
	border: solid 1px rgba(255, 87, 26, 0.3);
  text-align: center;
  color: #ff571a;
  font-size: 0.2rem;
`;
class NextCar extends Component {
    render() {
        const { carNumber, carName, style, className } = this.props;
        return (<Root className={`${className} textFlow`} style={style}>
          下一车辆 ({carNumber} {carName})
      </Root>);
    }
}
export default NextCar;
